import { Adapter } from '../adapters/Adapter';
import { Train } from './Train';
import { Entity } from './Entity';
import { BehaviorSubject } from 'rxjs';


export class Site implements Entity {
  public trains: Train[];
  public expanded = false;
  constructor(
    public siteId: number,
    public siteName: string,
    public customerId: number
  ) {

  }

  getId() {
    return this.siteId;
  }

  getType(): 'customer' | 'site' | 'train' {
    return 'site';
  }

  getName() {
    return this.siteName;
  }
}

export class SiteAdapter implements Adapter<Site> {
  public adapt(item): Site {
    return new Site(item.siteId, item.siteName, item.customerId);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Site.ts